import { render, staticRenderFns } from "./application-create.vue?vue&type=template&id=198f3a86&scoped=true&"
import script from "./application-create.vue?vue&type=script&lang=js&"
export * from "./application-create.vue?vue&type=script&lang=js&"
import style0 from "./application-create.vue?vue&type=style&index=0&id=198f3a86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f3a86",
  null
  
)

export default component.exports